module.exports = __webpack_public_path__ + "img/coupon-bg.288cc787.png";